export default (() => {
  const {
    getDocLink = () => ({})
  } = window.GLOBAL_INFO;
  return getDocLink();
});
//# sourceMappingURL=getDocLink.js.map
